import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificacionGestion } from '../../models/gestion-referidos.model';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class NotificacionGestionService {

  private baseUrl = `${ENV.HOST}${URL_MAP.API.GESTION_REFERIDOS}`;

  constructor(private http: HttpClient) {}

  guardar(gestion: NotificacionGestion): Observable<any> {
    return this.http.post(`${this.baseUrl}/guardar`, gestion);
  }

  mostrarTodos(): Observable<NotificacionGestion[]> {
    return this.http.get<NotificacionGestion[]>(`${this.baseUrl}/todas`);
  }

  obtenerPorAsesor(asesorId: string): Observable<NotificacionGestion[]> {
    return this.http.get<NotificacionGestion[]>(`${this.baseUrl}/por-asesor/${asesorId}`);
  }

  obtenerPorDetalle(idDetalle: number): Observable<NotificacionGestion[]> {
    return this.http.get<NotificacionGestion[]>(`${this.baseUrl}/detalle/${idDetalle}`);
  }
}